module.exports = __webpack_public_path__ + "assets/img/51@3x.dfa940c3.png";